import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
import { table } from 'console';
declare var $;

@Component({
  selector: 'app-manuflow-dashboard',
  templateUrl: './manuflow-dashboard.component.html',
  styleUrls: ['./manuflow-dashboard.component.css']
})
/** manuflow-dashboard component*/
export class ManuflowDashboardComponent {
  /** manuflow-dashboard ctor */

  showModal: boolean;
  showModalDocList: boolean;
  title: string;
  dataTable: any;
  dataTable_PreEdit: any;
  zPublisherId: any;
  dataSet: any;
  @ViewChild('dataTable,dataTable_PreEdit', { static: false }) table;


  constructor() {
    localStorage.aEID = 0;
    localStorage.aLoadType = 'WIP';
    localStorage.ModuleName = 'ManuflowDashboard';
    this.zPublisherId = "10" //localStorage.aPubID;
  }
  ngOnInit(): void {
    this.LoadGeneralFunctions();
  }

  LoadGeneralFunctions() {
    this.get_Dashboard_ManuflowSummary();
    this.get_Manuflow_ArticleList();
  }

  get_Dashboard_ManuflowSummary(): void {
    $("#LoadingImage").show();
    var adataitemL = {
      ID: localStorage.aEID,
      LoginId: localStorage.aLoginID,
      PublisherId: this.zPublisherId
    };
    $("#Summary_Booking_count").html('0');
    $("#Summary_inprocess_count").html('0');
    $("#Summary_overdue_count").html('0');
    $("#Summary_failure_count").html('0');
    $("#Summary_proofing_count").html('0');

    ApiMethod.postMethod('manuflow/DashboardSummary', adataitemL).subscribe(
      result => {
        let SummaryList = result.summaryList;
        $("#Summary_Booking_count").html(SummaryList[0].YetToUpload);
        $("#Summary_inprocess_count").html(SummaryList[0].Processing);
        $("#Summary_overdue_count").html(SummaryList[0].OverDue);
        $("#Summary_failure_count").html(SummaryList[0].Failure);
        $("#Summary_proofing_count").html(SummaryList[0].YetToProofing);
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  Show_Card_Details(y): void {

    $('.card-sel').removeClass('card-sel');
    $('div[data-val="contentPane"]').hide();
    $("#contentPane_" + y).show();
    $('#' + y + '_card').addClass("card-sel");

    if (y == 'Booking') {
      localStorage.aLoadType = 'WIP';
      localStorage.ModuleName = 'ManuflowDashboard'
    }
    else { localStorage.aLoadType = y; }

    if (y == 'PreEdit') { $("#contentPane_Booking").show(); localStorage.ModuleName = 'ManuflowDashboard_preEdit' }

    this.get_Manuflow_ArticleList();
  }

  get_Manuflow_ArticleList(): void {
    $("#LoadingImage").show();
    // $("#tblmanuflow_ArticleList tbody").html("");

    var adataitemL = {
      ID: localStorage.aEID,
      PublisherId: this.zPublisherId,
      LoginId: localStorage.aLoginID,
      ModuleName: localStorage.ModuleName,
      LoadType: localStorage.aLoadType,
      TransMasterID: 0
    };

    ApiMethod.postMethod('manuflow/GetManuflowArticleList', adataitemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.articleList); // Data List
        this.dataSet = JSON.parse(this.dataSet);

        // 
        if (result.articleList.length <= 0) {
          $('div[data-val="contentPane"]').hide();
          $('#contentPane_Nodatafound').show();
          $("#LoadingImage").hide();
          return false;
        }
        else {
          $('#contentPane_Nodatafound').hide();
        }
        //

        // Booking Article (WIP) - START
        if (localStorage.aLoadType == 'WIP') {
          $('#DataTables_Table_0').DataTable().destroy();
          $('#DataTables_Table_0').empty();
          this.dataTable = $(this.table.nativeElement);
          //Dynamic datable
          let aColList = result.aColListL;
          let dataItem = new DataParam();
          dataItem.acolList = aColList;
          //dataItem.aNewButtonName = 'btn_AddNew';
          dataItem.dataTable = this.dataTable;
          dataItem.dataset = this.dataSet;
          dataItem.dtheight = (GlobalConstants.size.height - 270);
          dataItem.modulename = localStorage.ModuleName;
          dataItem.rowSelect = true;
          this.dataTable = customfunctions.dynamicDataTable(dataItem);
        }
        // Booking Article (WIP) - END


        // Auto Structure Article - START
        if (localStorage.aLoadType == 'AutoStructure' || localStorage.aLoadType == 'Failure') {

          var zJournal = '';
          var zArticle = '';
          var BindHtml = '';
          var RowHtml = '';
          var itrLoop_Index = 1;

          // PLCurrentStatus = 0
          var yet_to_Start = '<td title="Yet to start"><svg class="bi text-muted flex-shrink-0" width="1.75em" height="1.75em"><use xlink:href="#cloud" /></svg></td></tr>';
          // PLCurrentStatus = 1
          var in_Process = '<td title="In process"><div style="width: 1rem;height: 1rem;" class="spinner-border text-info" role="status"><span class="visually-hidden">Loading...</span></div></td></tr>';
          // PLCurrentStatus = 2
          var zCompleted = '<td title="Completed"><svg class="bi text-muted flex-shrink-0" width="1.75em" height="1.75em"><use xlink:href="#completed_task" /></svg></td></tr>';
          // PLCurrentStatus = 3
          var zFailed = '<td title="Failed"><svg class="bi text-muted flex-shrink-0" width="1.75em" height="1.75em"><use xlink:href="#failed_task" /></svg></td></tr>';

          $.each(result.articleList, (e, items) => {
            //  if (zJournal != items.Journal && zArticle != items.ArticleNo) {
            if (zArticle != items.ArticleNo) {

              if (itrLoop_Index != 1) {
                BindHtml = BindHtml.replace('[tbodyContent]', RowHtml);
                RowHtml = '';
              }
              var Temp_Html = $(".autostruct_template").html();

              if (localStorage.aLoadType == 'AutoStructure') {
                Temp_Html = Temp_Html.replace('[taskicon]', 'gear');
              }
              else if (localStorage.aLoadType == 'Failure') {
                Temp_Html = Temp_Html.replace('[taskicon]', 'failure');
              }

              BindHtml += Temp_Html.replace('[articleid]', items.ArticleNo).replace('[articletitle]', items.ArticleTitle);

              RowHtml += '<tr><td>' + items.DisplayName + '</td>';
              RowHtml += '<td>' + GlobalConstants.FormatDateTime(items.StartDate) + '</td>';
              RowHtml += '<td>' + GlobalConstants.FormatDateTime(items.Completed) + '</td>';

              if (items.PLCurrentStatus == 0)
                RowHtml += yet_to_Start;
              else if (items.PLCurrentStatus == 1)
                RowHtml += in_Process;
              else if (items.PLCurrentStatus == 2)
                RowHtml += zCompleted;
              else if (items.PLCurrentStatus == 3)
                RowHtml += zFailed;
            }
            else {
              RowHtml += '<tr><td>' + items.DisplayName + '</td>';
              RowHtml += '<td>' + GlobalConstants.FormatDateTime(items.StartDate) + '</td>';
              RowHtml += '<td>' + GlobalConstants.FormatDateTime(items.Completed) + '</td>';
              if (items.PLCurrentStatus == 0)
                RowHtml += yet_to_Start;
              else if (items.PLCurrentStatus == 1)
                RowHtml += in_Process;
              else if (items.PLCurrentStatus == 2)
                RowHtml += zCompleted;
              else if (items.PLCurrentStatus == 3)
                RowHtml += zFailed;
            }

            if (itrLoop_Index == result.articleList.length) {
              BindHtml = BindHtml.replace('[tbodyContent]', RowHtml);
              RowHtml = '';
            }
            itrLoop_Index++;

            zJournal = items.Journal;
            zArticle = items.ArticleNo;
          });

          $("#contentPane_AutoStructure").html(BindHtml);
          if (localStorage.aLoadType == 'Failure') { $("#contentPane_AutoStructure").show(); $(".progress").hide(); }
          if (localStorage.aLoadType == 'AutoStructure') { $(".progress").show(); }
        }
        // Auto Structure Article - END



        // Pre-Editing - START
        if (localStorage.aLoadType == 'PreEdit') {
          $('#DataTables_Table_0').DataTable().destroy();
          $('#DataTables_Table_0').empty();
          this.dataTable = $(this.table.nativeElement);
          //Dynamic datable
          let aColList = result.aColListL;
          let dataItem = new DataParam();
          dataItem.acolList = aColList;
          dataItem.aNewButtonName = 'btn_AddNew';
          dataItem.dataTable = this.dataTable;
          dataItem.dataset = this.dataSet;
          dataItem.dtheight = (GlobalConstants.size.height - 270);
          dataItem.modulename = localStorage.ModuleName;
          dataItem.rowSelect = true;
          this.dataTable = customfunctions.dynamicDataTable(dataItem);

          //  $(".bxs-edit-alt").attr("title", "Report");
          //  $(".bxs-edit-alt").attr("class", "bx bxs-file");

        }
        // Pre-Editing - END


        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Bootstrap Modal Close event
  hide() {
    this.showModal = false;
    this.showModalDocList = false;
  }

  Show_Manuflow_HtmlReport(): void {
    $("#divReportdata").html('');
    if (localStorage.aEID != 0) {
      $("#LoadingImage").show();
      //var id = $(this).closest("tr").find("td:first").html();
      var adataReport_itemL = {
        ID: localStorage.aEID,
        PublisherId: this.zPublisherId,
        LoginId: localStorage.aLoginID,
        ModuleName: localStorage.ModuleName,
        LoadType: 'PreEditReport',
        TransMasterID: localStorage.aEID
      };
      ApiMethod.postMethod('manuflow/GetManuflowArticleList', adataReport_itemL).subscribe(
        result_list => {
          $("#LoadingImage").show();
          /////////////////////////

          var zJournal = '';
          var zArticle = '';
          var BindHtml = '';
          var RowHtml = '';
          var itrLoop_Index = 1;
          var Json_format_Report = '';

          // PLCurrentStatus = 0
          var yet_to_Start = '<td title="Yet to start"><svg class="bi text-muted flex-shrink-0" width="1.75em" height="1.75em"><use xlink:href="#cloud" /></svg></td></tr>';
          // PLCurrentStatus = 1
          var in_Process = '<td title="In process"><div style="width: 1rem;height: 1rem;" class="spinner-border text-info" role="status"><span class="visually-hidden">Loading...</span></div></td></tr>';
          // PLCurrentStatus = 2
          var zCompleted = '<td title="Completed"><svg class="bi text-muted flex-shrink-0" width="1.75em" height="1.75em"><use xlink:href="#completed_task" /></svg></td></tr>';
          // PLCurrentStatus = 3
          var zFailed = '<td title="Failed"><svg class="bi text-muted flex-shrink-0" width="1.75em" height="1.75em"><use xlink:href="#failed_task" /></svg></td></tr>';

          // PL file status - START
          $.each(result_list.articleList, (e, items) => {
            //  if (zJournal != items.Journal && zArticle != items.ArticleNo) {
            if (zArticle != items.ArticleNo) {
              Json_format_Report = items.SuccessResult;

              if (itrLoop_Index != 1) {
                BindHtml = BindHtml.replace('[tbodyContent]', RowHtml);
                RowHtml = '';
              }
              var Temp_Html = $(".autostruct_template").html();
              Temp_Html = Temp_Html.replace('[taskicon]', 'html-file');

              BindHtml += Temp_Html.replace('[articleid]', items.ArticleNo).replace('[articletitle]', items.ArticleTitle);

              RowHtml += '<tr><td>' + items.DisplayName + '</td>';
              RowHtml += '<td>' + GlobalConstants.FormatDateTime(items.StartDate) + '</td>';
              RowHtml += '<td>' + GlobalConstants.FormatDateTime(items.Completed) + '</td>';

              if (items.PLCurrentStatus == 0)
                RowHtml += yet_to_Start;
              else if (items.PLCurrentStatus == 1)
                RowHtml += in_Process;
              else if (items.PLCurrentStatus == 2)
                RowHtml += zCompleted;
              else if (items.PLCurrentStatus == 3)
                RowHtml += zFailed;
            }
            else {
              RowHtml += '<tr><td>' + items.DisplayName + '</td>';
              RowHtml += '<td>' + GlobalConstants.FormatDateTime(items.StartDate) + '</td>';
              RowHtml += '<td>' + GlobalConstants.FormatDateTime(items.Completed) + '</td>';
              if (items.PLCurrentStatus == 0)
                RowHtml += yet_to_Start;
              else if (items.PLCurrentStatus == 1)
                RowHtml += in_Process;
              else if (items.PLCurrentStatus == 2)
                RowHtml += zCompleted;
              else if (items.PLCurrentStatus == 3)
                RowHtml += zFailed;
            }

            if (itrLoop_Index == result_list.articleList.length) {
              BindHtml = BindHtml.replace('[tbodyContent]', RowHtml);
              RowHtml = '';
            }
            itrLoop_Index++;

            zJournal = items.Journal;
            zArticle = items.ArticleNo;
          });

          $("#divReport_Progress").html(BindHtml);
          $("#divReport_Progress .progress").remove();
          // PL file status - END
          var file_Name = '';
          if (Json_format_Report != '') {
            let obj_json = JSON.parse(Json_format_Report);

            var Temp_Report_Html = $(".assessment_report_template").html();
            var Final_Report_Html = '';
            for (var key in obj_json) {
              for (var key1 in obj_json[key]) {
                var Temp_row = '';
                for (var key2 in obj_json[key][key1]) {
                  if (key2 == "File_Name") {
                    file_Name = obj_json[key][key1][key2].toString();
                  }
                  Temp_row += '<tr><td>' + key2.replace('_', ' ') + '</td><td>' + obj_json[key][key1][key2].replace('_', ' ') + '</td></tr>'
                  // alert(key2);
                  // alert(obj_json[key][key1][key2].toString());
                }

                Final_Report_Html += Temp_Report_Html.replace('[headingtype]', key1.replace('_', ' ')).replace('[tbodyContent]', Temp_row)
              }
              //Final_Report_Html += Final_Report_Html;
            }

          }

          $("#divReport_data").html(Final_Report_Html);


          this.showModal = true; // Show-Hide Modal Check
          this.title = "Manuscript Assessment Report - " + file_Name;    // Dynamic Data

          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });

    }

  }

  FileMSUploadChangeEvent(fileInput: any) {
    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
        this.ManuscriptUpload();
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  fileBase64: string = "";
  ManuscriptUpload(): void {
    let fileName: string = '';
    let idInput = (<HTMLInputElement>document.getElementById('FU_ManuscriptUpload')).files;
    if (idInput.length > 0) {
      fileName = idInput[0].name;
    }

    if (fileName == '') {
      ngswal("Failed !", 'Invalid File Name', "warning");
    }
    else {
      $('#FU_ManuscriptUpload').val('');
      $("#LoadingImage").show();
      var dataParam = {
        LoginId: localStorage.aLoginID,
        PublisherId: this.zPublisherId,
        ArticleId: localStorage.aEID,
        FileAsBase64: this.fileBase64,
        FileName: fileName,
      }
      ApiMethod.postMethod('manuflow/upload', dataParam).subscribe(
        resonse => {
          let resultData = resonse;
          $("#LoadingImage").hide();
          if (resultData.Status == 'Success') {
            ngswal("Info!", resultData.Message, "warning");
            this.LoadGeneralFunctions();
          }
          else {
            ngswal("Failed!", resultData.Message, "warning");
          }

        },
        error => {
          ngswal("Failed!", error.error.Message, "warning");
          $("#LoadingImage").hide();
        }
      );
      console.log(dataParam);
    }
  }

  MergeDocFiles() {
    var FinalMergeJSON = '';
    var SelFileJSON = '';
    var UnSelFileJSON = '';
    var i = 1;
    $("#LoadingImage").hide();
    $("#Tbl-File-Merge tbody tr").each(function () {
      if ($($(this).find("input[type=checkbox]"))[0].checked) {
        SelFileJSON += '{ "Filename":"' + $($(this).find('td')[1]).html() + '", "Sequence":"' + (i++) + '" },'
      }
      else {
        UnSelFileJSON += '{ "Filename":"' + $($(this).find('td')[1]).html() + '", "Sequence":"0" },'
      }
    });

    if (SelFileJSON != '') {
      FinalMergeJSON = '{"Filelist":[' + SelFileJSON + UnSelFileJSON + ']}';
      FinalMergeJSON = FinalMergeJSON.replace('},]}', '}]}');
    }
    else {
      ngswal("Failed !", "Please select merge file list", "warning");
    }
  }


  Show_DocFileMerge() {

    $("#LoadingImage").show();
    $("#chk_SelectAll").prop('checked', false);

    if (localStorage.aEID != 0) {

      $("#LoadingImage").show();
      var JsonBindHTML = '';
      var CtrlHtml = '<td class="text-center"><span><i style="font-size: x-large;color: blue;cursor: pointer;" class="bx bx-download merge-download" title="download"></i></span></td><td class="text-center"><span class="btnup"><i style="font-size: x-large;color: #1db1a9;cursor: pointer;" class="bx bxs-up-arrow-circle" title="Up"></i></span><span class="btndown"><i style="font-size: x-large;color: #1db1a9;cursor: pointer;margin-left:10px;" class="bx bxs-down-arrow-circle" title="Down"></i></span></td></tr>';
      ApiMethod.getMethod('manuflow/docmergeJSON/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();
          let obj_docjson = JSON.parse(result.aJSONstr.DocMergeJson);
          for (var key in obj_docjson) {
            for (var key1 in obj_docjson[key]) {
              JsonBindHTML += '<tr><td class="text-center"><input style="width: 15px;height: 15px;" type="checkbox" #chkstatus# name="selectFile"></td>';
              for (var key2 in obj_docjson[key][key1]) {
                if (obj_docjson[key][key1][key2] == '0') {
                  JsonBindHTML = JsonBindHTML.replace('#chkstatus#', '');
                  JsonBindHTML += '<td class="text-center"> - </td>';
                }
                else if (obj_docjson[key][key1][key2] > 0) {
                  JsonBindHTML = JsonBindHTML.replace('#chkstatus#', 'checked');
                  JsonBindHTML += '<td class="text-center"> Yes </td>';
                }
                else {
                  JsonBindHTML += '<td>' + obj_docjson[key][key1][key2] + '</td>';
                }
              }
              JsonBindHTML += CtrlHtml;
            }
          }
          if (JsonBindHTML != '') {
            $("#Tbl-File-Merge tbody").html(JsonBindHTML);
          }


          $(".bxs-up-arrow-circle,.bxs-down-arrow-circle").click(function () {
            //alert('test');
            var row = $(this).parents("tr:first");
            if ($(this).is(".bxs-up-arrow-circle")) {
              row.insertBefore(row.prev());
            } else {
              row.insertAfter(row.next());
            }
           
          });

        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }

    // Show-Hide Modal Check
    this.showModalDocList = true;

    $("#chk_SelectAll").click(function () {
      $("input[name=selectFile]").prop('checked', $(this).prop('checked'));
    });

    $("#LoadingImage").hide();
    this.title = "Manuscript File Merging";
  }

}
